module.exports = __webpack_public_path__ + "img/banner.7a0a291c.jpg";